export var AssetFinanceType;
(function (AssetFinanceType) {
    AssetFinanceType["BusinessLoanWorkingCapital"] = "BUSINESS_LOAN_OR_WORKING_CAPITAL";
    AssetFinanceType["DebtConsolidation"] = "DEBT_CONSOLIDATION";
    AssetFinanceType["HomeImprovement"] = "HOME_IMPROVEMENT";
    AssetFinanceType["LeisureAsset"] = "LEISURE_ASSET";
    AssetFinanceType["OtherPersonal"] = "OTHER_OR_PERSONAL";
    AssetFinanceType["PlantAndEquipment"] = "PLANT_AND_EQUIPMENT";
    AssetFinanceType["VehicleLoan"] = "VEHICLE_LOAN";
})(AssetFinanceType || (AssetFinanceType = {}));
export var ClientStatus;
(function (ClientStatus) {
    ClientStatus["ExistingCustomerWithHomeLoan"] = "EXISTING_HOME_LOAN_CUSTOMER";
    ClientStatus["ExistingCustomerWithoutHomeLoan"] = "EXISTING_CUSTOMER_NO_HOME_LOAN";
    ClientStatus["NewCustomer"] = "NEW_CUSTOMER_NO_PRIOR_RELATIONSHIP";
})(ClientStatus || (ClientStatus = {}));
export var FinanceStage;
(function (FinanceStage) {
    FinanceStage["NoQuote"] = "NO_QUOTE";
    FinanceStage["QuoteHeld"] = "QUOTE_HELD";
    FinanceStage["Unknown"] = "UNKNOWN";
})(FinanceStage || (FinanceStage = {}));
export var IntentToBuy;
(function (IntentToBuy) {
    IntentToBuy["EnquiryOnly"] = "ENQUIRY_ONLY";
    IntentToBuy["ReadyToGo"] = "READY_TO_GO";
    IntentToBuy["Unknown"] = "UNKNOWN";
})(IntentToBuy || (IntentToBuy = {}));
export var LoanCategory;
(function (LoanCategory) {
    LoanCategory["Commercial"] = "COMMERCIAL";
    LoanCategory["Consumer"] = "CONSUMER";
})(LoanCategory || (LoanCategory = {}));
export var BusinessLoanWorkingCapitalLoanType;
(function (BusinessLoanWorkingCapitalLoanType) {
    BusinessLoanWorkingCapitalLoanType["BusinessOverdraft"] = "BUSINESS_OVERDRAFT";
    BusinessLoanWorkingCapitalLoanType["InsurancePremium"] = "INSURANCE_PREMIUM";
    BusinessLoanWorkingCapitalLoanType["InvoiceFinance"] = "INVOICE_FINANCE";
    BusinessLoanWorkingCapitalLoanType["LineOfCredit"] = "LINE_OF_CREDIT";
    BusinessLoanWorkingCapitalLoanType["Other"] = "OTHER";
    BusinessLoanWorkingCapitalLoanType["UnsecuredBusinessLoans"] = "UNSECURED_BUSINESS_LOANS";
})(BusinessLoanWorkingCapitalLoanType || (BusinessLoanWorkingCapitalLoanType = {}));
export var LeisureAssetLoanType;
(function (LeisureAssetLoanType) {
    LeisureAssetLoanType["MarineAsset"] = "BOAT_JETSKI";
    LeisureAssetLoanType["Other"] = "OTHER";
    LeisureAssetLoanType["WheeledAsset"] = "CARAVAN_HORSEFLOAT_TRAILER";
})(LeisureAssetLoanType || (LeisureAssetLoanType = {}));
export var OtherPersonalLoanType;
(function (OtherPersonalLoanType) {
    OtherPersonalLoanType["Dental"] = "DENTAL";
    OtherPersonalLoanType["Education"] = "EDUCATION";
    OtherPersonalLoanType["Furnishings"] = "FURNISHINGS";
    OtherPersonalLoanType["Medical"] = "MEDICAL";
    OtherPersonalLoanType["Other"] = "OTHER";
    OtherPersonalLoanType["Travel"] = "TRAVEL";
    OtherPersonalLoanType["WeddingOrFuneral"] = "WEDDING_OR_FUNERAL";
})(OtherPersonalLoanType || (OtherPersonalLoanType = {}));
export var PlantAndEquipmentLoanType;
(function (PlantAndEquipmentLoanType) {
    PlantAndEquipmentLoanType["BusinessEquipment"] = "GENERATORS_MACHINERY_GYM_EQUIPMENT";
    PlantAndEquipmentLoanType["FitoutFinance"] = "FITOUT_FINANCE";
    PlantAndEquipmentLoanType["Other"] = "OTHER";
    PlantAndEquipmentLoanType["TruckAndTrailer"] = "TRUCK_AND_TRAILER";
    PlantAndEquipmentLoanType["WheeledAssets"] = "TRACTORS_EXCAVATORS_LIFTS";
})(PlantAndEquipmentLoanType || (PlantAndEquipmentLoanType = {}));
export var VehicleCondition;
(function (VehicleCondition) {
    VehicleCondition["Demo"] = "DEMO";
    VehicleCondition["New"] = "NEW";
    VehicleCondition["Unknown"] = "UNKNOWN";
    VehicleCondition["Used"] = "USED";
})(VehicleCondition || (VehicleCondition = {}));
export var VehicleFinanceStage;
(function (VehicleFinanceStage) {
    VehicleFinanceStage["BankOrOtherLenderQuote"] = "BANK_OR_OTHER_LENDER_QUOTE";
    VehicleFinanceStage["DealerQuote"] = "DEALER_QUOTE";
    VehicleFinanceStage["NoQuoteHeld"] = "NO_QUOTE_HELD";
    VehicleFinanceStage["Unknown"] = "UNKNOWN";
})(VehicleFinanceStage || (VehicleFinanceStage = {}));
export var VehicleIntentToBuy;
(function (VehicleIntentToBuy) {
    VehicleIntentToBuy["BuyNowVehicleInMind"] = "BUY_NOW_VEHICLE_IN_MIND";
    VehicleIntentToBuy["BuyNowNoVehicleInMind"] = "BUY_NOW_NO_VEHICLE_IN_MIND";
    VehicleIntentToBuy["EnquiryOnly"] = "ENQUIRY_ONLY";
    VehicleIntentToBuy["Unknown"] = "UNKNOWN";
})(VehicleIntentToBuy || (VehicleIntentToBuy = {}));
export var VehicleMake;
(function (VehicleMake) {
    VehicleMake["Abarth"] = "Abarth";
    VehicleMake["Alfa Romeo"] = "Alfa Romeo";
    VehicleMake["Aston Martin"] = "Aston Martin";
    VehicleMake["Audi"] = "Audi";
    VehicleMake["BMW"] = "BMW";
    VehicleMake["Bentley"] = "Bentley";
    VehicleMake["Caterham"] = "Caterham";
    VehicleMake["Chery"] = "Chery";
    VehicleMake["Chrysler"] = "Chrysler";
    VehicleMake["Citroen"] = "Citroen";
    VehicleMake["Dodge"] = "Dodge";
    VehicleMake["Ferrari"] = "Ferrari";
    VehicleMake["Fiat"] = "Fiat";
    VehicleMake["Ford"] = "Ford";
    VehicleMake["Foton"] = "Foton";
    VehicleMake["Geely"] = "Geely";
    VehicleMake["Great Wall"] = "Great Wall";
    VehicleMake["HSV"] = "HSV";
    VehicleMake["Holden"] = "Holden";
    VehicleMake["Honda"] = "Honda";
    VehicleMake["Hummer"] = "Hummer";
    VehicleMake["Hyundai"] = "Hyundai";
    VehicleMake["Infiniti"] = "Infiniti";
    VehicleMake["Isuzu"] = "Isuzu";
    VehicleMake["Jaguar"] = "Jaguar";
    VehicleMake["Jeep"] = "Jeep";
    VehicleMake["Kia"] = "Kia";
    VehicleMake["LDV"] = "LDV";
    VehicleMake["Lamborghini"] = "Lamborghini";
    VehicleMake["Land Rover"] = "Land Rover";
    VehicleMake["Lexus"] = "Lexus";
    VehicleMake["Lotus"] = "Lotus";
    VehicleMake["M.G."] = "M.G.";
    VehicleMake["Mahindra"] = "Mahindra";
    VehicleMake["Maserati"] = "Maserati";
    VehicleMake["Maybach"] = "Maybach";
    VehicleMake["Mazda"] = "Mazda";
    VehicleMake["Mclaren"] = "Mclaren";
    VehicleMake["Mercedes-Benz"] = "Mercedes-Benz";
    VehicleMake["Mini"] = "Mini";
    VehicleMake["Mitsubishi"] = "Mitsubishi";
    VehicleMake["Morgan"] = "Morgan";
    VehicleMake["Nissan"] = "Nissan";
    VehicleMake["Opel"] = "Opel";
    VehicleMake["Other"] = "Other";
    VehicleMake["Peugeot"] = "Peugeot";
    VehicleMake["Porsche"] = "Porsche";
    VehicleMake["Proton"] = "Proton";
    VehicleMake["Range Rover"] = "Range Rover";
    VehicleMake["Renault"] = "Renault";
    VehicleMake["Rolls-Royce"] = "Rolls-Royce";
    VehicleMake["Saab"] = "Saab";
    VehicleMake["Skoda"] = "Skoda";
    VehicleMake["Smart"] = "Smart";
    VehicleMake["Ssangyong"] = "Ssangyong";
    VehicleMake["Subaru"] = "Subaru";
    VehicleMake["Suzuki"] = "Suzuki";
    VehicleMake["Tata"] = "Tata";
    VehicleMake["Tesla"] = "Tesla";
    VehicleMake["Toyota"] = "Toyota";
    VehicleMake["Volkswagen"] = "Volkswagen";
    VehicleMake["Volvo"] = "Volvo";
    VehicleMake["ZX Auto"] = "ZX Auto";
})(VehicleMake || (VehicleMake = {}));
export var VehicleModel = {
    Abarth: ['500', '595', '695', 'Other'],
    'Alfa Romeo': ['147', '156', '159', '166', '4C', 'Brera', 'GT', 'Giulietta', 'Mito', 'Spider', 'Other'],
    'Aston Martin': ['DB7', 'DB9', 'DBS', 'Rapide', 'V12', 'V8', 'Vanquish', 'Virage', 'Other'],
    Audi: [
        'A1',
        'A3',
        'A4',
        'A5',
        'A6',
        'A7',
        'A8',
        'Allroad Quattro',
        'Q3',
        'Q5',
        'Q7',
        'R8',
        'RS Q3',
        'RS4',
        'RS5',
        'RS6',
        'RS7',
        'S1',
        'S3',
        'S4',
        'S5',
        'S6',
        'S7',
        'S8',
        'SQ5',
        'TT',
        'Other',
    ],
    BMW: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        'I3',
        'I8',
        'M3',
        'M4',
        'M5',
        'M6',
        'X1',
        'X3',
        'X4',
        'X5',
        'X6',
        'Z4',
        'Other',
    ],
    Bentley: ['Arnage', 'Continental', 'Flying Spur', 'Mulsanne', 'Other'],
    Caterham: ['Seven', 'Other'],
    Chery: ['J1', 'J11', 'J3', 'Other'],
    Chrysler: ['300', '300C', 'Crossfire', 'Grand Voyager', 'PT Cruiser', 'Sebring', 'Voyager', 'Other'],
    Citroen: [
        'Berlingo',
        'Berlingo II',
        'C2',
        'C3',
        'C4',
        'C4 Grand Picasso',
        'C4 Picasso',
        'C5',
        'C6',
        'DS3',
        'DS4',
        'DS5',
        'Dispatch',
        'Grand C4',
        'Other',
    ],
    Dodge: ['Avenger', 'Caliber', 'Journey', 'Nitro', 'Other'],
    Ferrari: ['458', '599', '612', 'California', 'F12', 'F430', 'FF', 'Superamerica', 'Other'],
    Fiat: ['500', 'Doblo', 'Freemont', 'Panda', 'Punto', 'Ritmo', 'Scudo', 'Other'],
    Ford: [
        'Courier',
        'Econovan',
        'Ecosport',
        'Escape',
        'Explorer',
        'F250',
        'F350',
        'FPV',
        'Fairlane',
        'Fairmont',
        'Falcon',
        'Fiesta',
        'Focus',
        'G6',
        'Kuga',
        'LTD',
        'Mondeo',
        'Ranger',
        'Territory',
        'Transit',
        'Transit Custom',
        'Other',
    ],
    Foton: ['Tunland', 'Other'],
    Geely: ['MK', 'Other'],
    'Great Wall': ['SA220', 'V200', 'V240', 'X200', 'X240', 'Other'],
    HSV: ['Avalanche', 'Clubsport', 'Coupe', 'GTS', 'Grange', 'Maloo', 'SV6000', 'Senator', 'VXR', 'W427', 'Other'],
    Holden: [
        'Adventra',
        'Astra',
        'Barina',
        'Barina Spark',
        'Berlina',
        'Calais',
        'Caprice',
        'Captiva',
        'Colorado',
        'Colorado 7',
        'Combo',
        'Commodore',
        'Crewman',
        'Cruze',
        'Epica',
        'Malibu',
        'Monaro',
        'Rodeo',
        'Statesman',
        'Tigra',
        'Trax',
        'UTE',
        'Vectra',
        'Viva',
        'Volt',
        'Zafira',
        'Other',
    ],
    Honda: [
        'Accord',
        'CR-Z',
        'CRV',
        'City',
        'Civic',
        'HR-V',
        'Insight',
        'Integra',
        'Jazz',
        'Legend',
        'MDX',
        'Odyssey',
        'S2000',
        'Other',
    ],
    Hummer: ['H3', 'Other'],
    Hyundai: [
        'Accent',
        'Elantra',
        'Genesis',
        'Getz',
        'Grandeur',
        'I20',
        'I30',
        'I40',
        'I45',
        'IX35',
        'Iload',
        'Imax',
        'Santa FE',
        'Sonata',
        'Terracan',
        'Tiburon',
        'Trajet',
        'Tucson',
        'Veloster',
        'Other',
    ],
    Infiniti: ['FX', 'G37', 'M', 'Q50', 'Q60', 'Q70', 'QX70', 'Other'],
    Isuzu: ['D-MAX', 'MU-X', 'Other'],
    Jaguar: ['F-Type', 'S Type', 'X Type', 'XF', 'XJ', 'XJ6', 'XJ8', 'XJR', 'XK', 'XK8', 'XKR', 'Other'],
    Jeep: ['Cherokee', 'Commander', 'Compass', 'Grand Cherokee', 'Patriot', 'Wrangler', 'Wrangler Unlimited', 'Other'],
    Kia: [
        'Carnival',
        'Cerato',
        'Grand Carnival',
        'K2700',
        'K2900',
        'Magentis',
        'Optima',
        'PRO CEE`D',
        'Pregio',
        'RIO',
        'Rondo',
        'Sorento',
        'Soul',
        'Sportage',
        'Other',
    ],
    LDV: ['V80', 'Other'],
    Lamborghini: ['Aventador', 'Gallardo', 'Huracan', 'Murcielago', 'Other'],
    'Land Rover': ['Defender', 'Discovery 3', 'Discovery 4', 'Freelander', 'Freelander 2', 'Other'],
    Lexus: [
        'CT 200H. Hybrid',
        'ES300',
        'ES300H',
        'ES350',
        'GS250',
        'GS300',
        'GS300H',
        'GS350',
        'GS430',
        'GS450H',
        'GS460',
        'IS F',
        'IS250',
        'IS250C',
        'IS300H',
        'IS350',
        'LFA',
        'LS430',
        'LS460',
        'LS600H',
        'LS600HL',
        'LX470',
        'LX570',
        'NX200T',
        'NX300H',
        'RC F',
        'RC350',
        'RX270',
        'RX330',
        'RX350',
        'RX400H',
        'RX450H',
        'SC430',
        'Other',
    ],
    Lotus: ['Elise', 'Europa', 'Evora', 'Exige', 'Other'],
    'M.G.': ['MG6', 'Other'],
    Mahindra: ['Genio', 'PIK-UP', 'XUV500', 'Other'],
    Maserati: ['Coupe', 'Ghibli', 'Grancabrio', 'Gransport', 'Granturismo', 'Quattroporte', 'Spyder', 'Other'],
    Maybach: ['57', '62', 'Other'],
    Mazda: [
        'B2500',
        'B2600',
        'B4000',
        'BT50',
        'CX-5',
        'CX-7',
        'CX-9',
        'E1800',
        'E2000',
        'MPV',
        'MX-5',
        'Mazda2',
        'Mazda3',
        'Mazda6',
        'RX-8',
        'Tribute',
        'Other',
    ],
    Mclaren: ['MP4-12C', 'Other'],
    'Mercedes-Benz': [
        'A150',
        'A170',
        'A180',
        'A200',
        'A250',
        'A45',
        'B180',
        'B200',
        'B250',
        'C180',
        'C200',
        'C220',
        'C230',
        'C250',
        'C280',
        'C300',
        'C320',
        'C350',
        'C55',
        'C63',
        'CL',
        'CL500',
        'CL600',
        'CLA',
        'CLC',
        'CLK200K',
        'CLK280',
        'CLK350',
        'CLK500',
        'CLK55',
        'CLK63',
        'CLS',
        'E200',
        'E200K',
        'E220',
        'E250',
        'E280',
        'E300',
        'E350',
        'E400',
        'E500',
        'E55',
        'E63',
        'G',
        'GL',
        'GLA',
        'ML',
        'R',
        'S300',
        'S320',
        'S350',
        'S400',
        'S430',
        'S500',
        'S55',
        'S600',
        'S63',
        'S65',
        'SL',
        'SL350',
        'SL500',
        'SL600',
        'SLK',
        'SLS',
        'Valente',
        'Viano',
        'Vito',
        'Other',
    ],
    Mini: ['Cooper', 'ONE', 'Other'],
    Mitsubishi: [
        '380',
        'ASX',
        'Challenger',
        'Colt',
        'Express',
        'Grandis',
        'I-Miev',
        'Lancer',
        'Mirage',
        'Outlander',
        'Pajero',
        'Triton',
        'Other',
    ],
    Morgan: ['3 Wheeler', '4/4', 'Aero Coupe', 'Aero Supersports', 'Plus 4', 'Plus 8', 'Roadster', 'Other'],
    Nissan: [
        '350Z',
        '370Z',
        'Almera',
        'Altima',
        'Dualis',
        'GT-R',
        'Juke',
        'Leaf',
        'Maxima',
        'Micra',
        'Murano',
        'Navara',
        'Pathfinder',
        'Patrol',
        'Pulsar',
        'Qashqai',
        'Tiida',
        'X-Trail',
        'Other',
    ],
    Opel: ['Astra', 'Corsa', 'Insignia', 'Zafira', 'Other'],
    Peugeot: [
        '206',
        '207',
        '208',
        '307',
        '308',
        '407',
        '508',
        '607',
        '2008',
        '3008',
        '4007',
        '4008',
        '5008',
        'Expert',
        'Partner',
        'RCZ',
        'Other',
    ],
    Porsche: ['911', 'Boxster', 'Cayenne', 'Cayman', 'Macan', 'Panamera', 'Other'],
    Proton: [
        'Exora',
        'GEN.2',
        'Jumbuck',
        'Persona',
        'Preve',
        'S16',
        'S16 FLX',
        'Satria',
        'Satria-NEO',
        'Savvy',
        'Suprima S',
        'Waja',
        'Other',
    ],
    'Range Rover': ['Evoque', 'Range Rover', 'Other'],
    Renault: [
        'Captur',
        'Clio',
        'Fluence',
        'Grand Scenic II',
        'Kangoo',
        'Koleos',
        'Laguna',
        'Latitude',
        'Megane',
        'Scenic II',
        'Trafic',
        'Other',
    ],
    'Rolls-Royce': ['Ghost', 'Phantom', 'Other'],
    Saab: ['9-3', '9-5', 'Turbo X', 'Other'],
    Skoda: ['Fabia', 'Octavia', 'Rapid Spaceback', 'Roomster', 'Superb', 'Yeti', 'Other'],
    Smart: ['Forfour', 'Fortwo', 'Roadster', 'Other'],
    Ssangyong: [
        'Actyon',
        'Actyon Sports',
        'Chairman',
        'Korando',
        'Kyron',
        'Musso',
        'Rexton',
        'Rexton II',
        'Stavic',
        'Other',
    ],
    Subaru: ['BRZ', 'Forester', 'Impreza', 'Liberty', 'Outback', 'Tribeca', 'WRX', 'XV', 'Other'],
    Suzuki: [
        'APV',
        'Alto',
        'Celerio',
        'Grand Vitara',
        'Jimny',
        'Kizashi',
        'Liana',
        'S-Cross',
        'SX4',
        'Swift',
        'XL-7',
        'Other',
    ],
    Tata: ['Xenon', 'Other'],
    Tesla: ['Model S', 'Other'],
    Toyota: [
        '86',
        'Aurion',
        'Avalon',
        'Avensis',
        'Camry',
        'Celica',
        'Corolla',
        'FJ Cruiser',
        'Hiace',
        'Hilux',
        'Kluger',
        'Landcruiser',
        'MR2',
        'Prius',
        'Prius V',
        'Prius-C',
        'RAV4',
        'Rukus',
        'TRD',
        'Tarago',
        'Yaris',
        'Other',
    ],
    Volkswagen: [
        'Amarok',
        'Beetle',
        'Bora',
        'CC',
        'Caddy',
        'Caravelle',
        'Citivan',
        'EOS',
        'Golf',
        'Jetta',
        'Kombi',
        'Multivan',
        'Passat',
        'Passat CC',
        'Polo',
        'Scirocco',
        'Tiguan',
        'Touareg',
        'Transporter',
        'UP!',
        'Other',
    ],
    Volvo: ['C30', 'C70', 'S40', 'S60', 'S80', 'V40', 'V50', 'V60', 'V70', 'XC60', 'XC70', 'XC90', 'Other'],
    'ZX Auto': ['Grand Tiger', 'Other'],
    Other: ['Other'],
};
export var PlatformFinanceStatus;
(function (PlatformFinanceStatus) {
    PlatformFinanceStatus["Accepted"] = "ACCEPTED";
    PlatformFinanceStatus["Application"] = "APPLICATION";
    PlatformFinanceStatus["Approved"] = "APPROVED";
    PlatformFinanceStatus["AppBooked"] = "APP_BOOKED";
    PlatformFinanceStatus["Assessment"] = "ASSESSMENT";
    PlatformFinanceStatus["AwaitingAcceptance"] = "AWAITING_ACCEPTANCE";
    PlatformFinanceStatus["CALL_ONE"] = "CALL_ONE";
    PlatformFinanceStatus["CALL_TWO"] = "CALL_TWO";
    PlatformFinanceStatus["Converted"] = "CONVERTED";
    PlatformFinanceStatus["DealLost"] = "DEAL_LOST";
    PlatformFinanceStatus["DnpMarket"] = "DNP_MARKET";
    PlatformFinanceStatus["Documents"] = "DOCUMENTS";
    PlatformFinanceStatus["FollowUp"] = "FOLLOW_UP";
    PlatformFinanceStatus["HotLead"] = "HOT_LEAD";
    PlatformFinanceStatus["NewLead"] = "NEW_LEAD";
    PlatformFinanceStatus["PendingInfo"] = "PENDING_INFO";
    PlatformFinanceStatus["PendingSupportingDocs"] = "PENDING_SUPPORTING_DOCS";
    PlatformFinanceStatus["QuoteSent"] = "QUOTE_SENT";
    PlatformFinanceStatus["ReferredToBroker"] = "REFERRED_TO_BROKER ";
    PlatformFinanceStatus["Settled"] = "SETTLED";
    PlatformFinanceStatus["SmsSent"] = "SMS_SENT";
    PlatformFinanceStatus["Workshop"] = "WORKSHOP";
})(PlatformFinanceStatus || (PlatformFinanceStatus = {}));
export var PlatformFinanceSubStatus;
(function (PlatformFinanceSubStatus) {
    PlatformFinanceSubStatus["AlternativeFunding"] = "ALTERNATIVE_FUNDING";
    PlatformFinanceSubStatus["ApplicationReceived"] = "APPLICATION_RECEIVED";
    PlatformFinanceSubStatus["ApplicationSent"] = "APPLICATION_SENT";
    PlatformFinanceSubStatus["AppointmentIncomplete"] = "APPOINTMENT_INCOMPLET";
    PlatformFinanceSubStatus["AwaitingFurtherInformation"] = "AWAITING_FURTHER_INFORMATION";
    PlatformFinanceSubStatus["AwaitingVehicle"] = "AWAITING_VEHICLE";
    PlatformFinanceSubStatus["BadCredit"] = "BAD_CREDIT";
    PlatformFinanceSubStatus["ChangedMind"] = "CHANGED_MIND";
    PlatformFinanceSubStatus["CouldNotContact"] = "COULD_NOT_CONTACT";
    PlatformFinanceSubStatus["DocumentsReceived"] = "DOCUMENTS_RECEIVED";
    PlatformFinanceSubStatus["DocumentsRequested"] = "DOCUMENTS_REQUESTED";
    PlatformFinanceSubStatus["DocumentsSent"] = "DOCUMENTS_SENT";
    PlatformFinanceSubStatus["Duplicate"] = "DUPLICATE";
    PlatformFinanceSubStatus["FutureContact"] = "FUTURE_CONTACT";
    PlatformFinanceSubStatus["InvoiceReceived"] = "INVOICE_RECEIVED";
    PlatformFinanceSubStatus["InvoiceRequested"] = "INVOICE_REQUESTED";
    PlatformFinanceSubStatus["Junk"] = "JUNK";
    PlatformFinanceSubStatus["Junklead"] = "JUNKLEAD";
    PlatformFinanceSubStatus["NoCapacity"] = "NO_CAPACITY";
    PlatformFinanceSubStatus["NoClientResponse"] = "NO_CLIENT_RESPONSE";
    PlatformFinanceSubStatus["Other"] = "OTHER";
    PlatformFinanceSubStatus["OtherFinancier"] = "OTHER_FINANCIER";
    PlatformFinanceSubStatus["OutsideGuidelines"] = "OUTSIDE_GUIDELINES";
    PlatformFinanceSubStatus["PreApproved"] = "PRE_APPROVED";
    PlatformFinanceSubStatus["QuoteOnly"] = "QUOTE_ONLY";
    PlatformFinanceSubStatus["ReadyForSettlement"] = "READY_FOR_SETTLEMENT";
    PlatformFinanceSubStatus["SentForSettlement"] = "SENT_FOR_SETTLEMENT";
    PlatformFinanceSubStatus["SubmissionRequest"] = "SUBMISSION_REQUEST";
    PlatformFinanceSubStatus["SubmittedToLender"] = "SUBMITTED_TO_LENDER";
})(PlatformFinanceSubStatus || (PlatformFinanceSubStatus = {}));
export var AssetFinanceCalculatedStage;
(function (AssetFinanceCalculatedStage) {
    AssetFinanceCalculatedStage["PreSubmission"] = "PRE_SUBMISSION";
    AssetFinanceCalculatedStage["ClosedLost"] = "CLOSED_LOST";
    AssetFinanceCalculatedStage["ApplicationLodgement"] = "APPLICATION_LODGEMENT";
    AssetFinanceCalculatedStage["Application"] = "APPLICATION";
    AssetFinanceCalculatedStage["Assessment"] = "ASSESSMENT";
    AssetFinanceCalculatedStage["Approval"] = "APPROVAL";
    AssetFinanceCalculatedStage["PreSettlement"] = "PRE_SETTLEMENT";
    AssetFinanceCalculatedStage["PostSettlement"] = "POST_SETTLEMENT";
})(AssetFinanceCalculatedStage || (AssetFinanceCalculatedStage = {}));
export var AssetFinanceCalculatedStatus;
(function (AssetFinanceCalculatedStatus) {
    AssetFinanceCalculatedStatus["InProgress"] = "IN_PROGRESS";
    AssetFinanceCalculatedStatus["LeadInProgress"] = "LEAD_IN_PROGRESS";
    AssetFinanceCalculatedStatus["OnHold"] = "ON_HOLD";
    AssetFinanceCalculatedStatus["SubmittedToLender"] = "SUBMITTED_TO_LENDER";
    AssetFinanceCalculatedStatus["SubmissionRequest"] = "SUBMISSION_REQUEST";
    AssetFinanceCalculatedStatus["MoreInformationRequested"] = "MORE_INFORMATION_REQUESTED";
    AssetFinanceCalculatedStatus["ApprovedInPrinciple"] = "APPROVED_IN_PRINCIPLE";
    AssetFinanceCalculatedStatus["InvoiceRequested"] = "INVOICE_REQUESTED";
    AssetFinanceCalculatedStatus["AwaitingVehicle"] = "AWAITING_VEHICLE";
    AssetFinanceCalculatedStatus["DocumentsRequested"] = "DOCUMENTS_REQUESTED";
    AssetFinanceCalculatedStatus["DocumentsIssued"] = "DOCUMENTS_ISSUED";
    AssetFinanceCalculatedStatus["DocumentsReceived"] = "DOCUMENTS_RECEIVED";
    AssetFinanceCalculatedStatus["ReadyForSettlement"] = "READY_FOR_SETTLEMENT";
    AssetFinanceCalculatedStatus["SettlementBooked"] = "SETTLEMENT_BOOKED";
    AssetFinanceCalculatedStatus["Settled"] = "SETTLED";
    AssetFinanceCalculatedStatus["Lost"] = "LOST";
})(AssetFinanceCalculatedStatus || (AssetFinanceCalculatedStatus = {}));
export var AssetFinanceReason;
(function (AssetFinanceReason) {
    AssetFinanceReason["AlternativeFunding"] = "ALTERNATIVE_FUNDING";
    AssetFinanceReason["Other"] = "OTHER";
    AssetFinanceReason["ChangedMind"] = "CHANGED_MIND";
    AssetFinanceReason["CouldNotContact"] = "COULD_NOT_CONTACT";
    AssetFinanceReason["FutureContact"] = "FUTURE_CONTACT";
    AssetFinanceReason["NoClientResponse"] = "NO_CLIENT_RESPONSE";
    AssetFinanceReason["QuoteOnly"] = "QUOTE_ONLY";
    AssetFinanceReason["BadCredit"] = "BAD_CREDIT";
    AssetFinanceReason["NoCapacity"] = "NO_CAPACITY";
    AssetFinanceReason["OtherFinancier"] = "OTHER_FINANCIER";
    AssetFinanceReason["OutsideGuidelines"] = "OUTSIDE_GUIDELINES";
    AssetFinanceReason["NotInterested"] = "NOT_INTERESTED";
})(AssetFinanceReason || (AssetFinanceReason = {}));
export var ReferralFeeType;
(function (ReferralFeeType) {
    ReferralFeeType["Dollar"] = "DOLLAR";
    ReferralFeeType["Percentage"] = "PERCENTAGE";
})(ReferralFeeType || (ReferralFeeType = {}));
//# sourceMappingURL=AssetFinance.js.map